{
  "PAGINATION_FOOTER": {
    "SHOWING": "Prikazano {startItem} - {endItem} od {totalItems} stavki",
    "CURRENT_PAGE_INFO": "Stranica {currentPage} od {totalPages}"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "Odaberite mogućnost...",
    "EMPTY_SEARCH_RESULTS": "Nema stavki za pojam pretraživanja `{searchTerm}`",
    "EMPTY_STATE": "Nisu pronađeni rezultati.",
    "SEARCH_PLACEHOLDER": "Pretraži...",
    "MORE": "+{count} više"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "Pretraži...",
    "EMPTY_STATE": "Nisu pronađeni rezultati.",
    "SEARCHING": "Tražim..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "Odustani",
      "CONFIRM": "Potvrdi"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "Pretraži državu",
    "ERROR": "Telefonski broj mora biti prazan ili u formatu E.164",
    "DIAL_CODE_ERROR": "Odaberite pozivni broj s popisa"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "Autor nije dostupan"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "Navigacijski put"
  },
  "SWITCH": {
    "TOGGLE": "Uključi/isključi"
  },
  "LABEL": {
    "TAG_BUTTON": "oznaka"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "Saznajte više",
    "WATCH_VIDEO": "Pogledajte video"
  },
  "COLOR_GRID": {
    "SHOW_COLORS": "Prikaži boje",
    "HIDE_COLORS": "Sakrij boje"
  },
  "DURATION_INPUT": {
    "MINUTES": "Minute",
    "HOURS": "Sati",
    "DAYS": "Dani",
    "PLACEHOLDER": "Unesite trajanje"
  }
}
